import { Injectable } from '@angular/core';
import { DateInt8, getDate8AsObject, ValueRange } from '@cawita/core-front';
import { format } from 'date-fns';
import { Stay } from '@shared/models/index';
import { AlertService } from '@mobile/services/commons/alert.service';

@Injectable({ providedIn: 'root' })
export class StayAlertService {
    constructor(
        private alert: AlertService,
    ) { }

    public confirmStayMerge(stays: (Stay | Partial<Stay>)[], newRange: ValueRange<DateInt8>) {
        const startDateAsString = format(getDate8AsObject(newRange.start), 'dd/MM/yy');
        const endDateAsString = format(getDate8AsObject(newRange.end), 'dd/MM/yy');
        return this.alert.confirm({
            title: { key: 'alert.stays-overlap-in-same-campings', params: { otherStays: stays?.length } },
            subtitle: { key: 'alert.new-stay-will-be-from-to', params: { start: startDateAsString, end: endDateAsString } },
            message: 'alert.continue-question',
        });
    }

    public confirmStayOverlap(stays: (Stay | Partial<Stay>)[]) {
        return this.alert.confirm({
            title: { key: 'alert.stays-overlap-in-other-campings', params: { otherStays: stays?.length } },
            subtitle: 'alert.all-these-stays-will-be-kept',
            message: 'alert.continue-question'
        });
    }
}
